export default __webpack_public_path__ + "static/media/bpmchart.b100412e.png";